<template>
  <!-- 需求详情 -->
  <div class="detail">
    <!-- title -->
    <headers :params="hraderP"></headers>
    <div class="detail-header">
      <p>项目信息</p>
      <p v-if="activeInfo.auditState === 0 || activeInfo.auditState === 1 || activeInfo.auditState === 3 || activeInfo.auditState === 4">{{activeInfo.auditState|stateFilter}}</p>
       <p v-else>{{activeInfo.quoteState|quoteStateFilter}}</p>
    </div>
    <div class="detai-list">
      <div class="detai-list-1">
        <p class="name">{{activeInfo.projectName}}</p>
        <p>项目费用: <span class="red"><span v-if="activeInfo.charge">￥</span> {{activeInfo.charge}}</span></p>
        <p>项目业态:
          <span v-for="item in activeInfo.buildingType" :key="item.id">{{ item.name }}</span>
          <span v-for="item in activeInfo.secondBuildingTypeList" :key="item.id">/ {{ item.name }}</span>
        </p>
        <p class="list">
          施工系统:
          <span v-for="item in activeInfo.systemList">{{item.name}}</span>
        </p>
        <div class="detai-list-2">
          <div class="item">
            <p>项目阶段:</p>
            <p>{{activeInfo.projectStage | stageFilter}}</p>
          </div>
          <div class="item">
            <p>产品交付:</p>
            <p>{{activeInfo.putType | typeFilter}}</p>
          </div>
          <div class="item">
            <p style="width: 80px;">产品时间:</p>
            <p v-if="activeInfo.auditState === 0 || activeInfo.auditState === 1 || activeInfo.auditState === 3 || activeInfo.auditState === 4||activeInfo.quoteState === 1">{{activeInfo.expectTime || '--'}}</p>
            <p v-else>{{activeInfo.deliverDay || '--'}}个工作日</p>
          </div>
          <div class="item">
            <p>项目地址:</p>
            <p>{{ activeInfo.provinceName }} <span v-if="activeInfo.provinceName">-</span> {{ activeInfo.cityName }}</p>
          </div>
        </div>
      </div>
      <div class="h12"></div>
      <div class="detai-list-3">
        <p class="number" style="margin-bottom: 0;">个人信息</p>
        <div class="detai-list-2" style="border: none;">
          <div class="item">
            <p>联系人:</p>
            <p>{{activeInfo.contacts}}</p>
          </div>
          <div class="item">
            <p>联系方式:</p>
            <p>{{activeInfo.mobile}}</p>
          </div>
          <div class="item">
            <p>公司名称:</p>
            <p>{{activeInfo.companyName}}</p>
          </div>
        </div>
      </div>
      <!-- 待确认报价 和已确认报价-->
      <div v-if="activeInfo.quoteState === 2||activeInfo.quoteState === 3">
        <div class="h12"></div>
        <div class="detai-list-3">
         <div class="detai-list-2" style="border: none;padding-top: 0;">
           <div class="item">
              <p>总报价:</p>
              <p class="red">¥{{activeInfo.charge}}</p>
           </div>
           <p class="font" v-if="activeInfo.quoteState === 3" style="color: #2F7BFF;text-decoration: underline;" @click="goHT(activeInfo)">电子合同</p>
          </div>
        </div>
      </div>
      <!-- 待确认报价 -->
      <div v-if="activeInfo.quoteState === 2">
        <div class="h12"></div>
        <div class="detai-list-3">
          <p class="number">备注</p>
          <p class="remark">{{activeInfo.description}}</p>
        </div>
      </div>

      <!-- 审核不通过 -->
      <div v-if="activeInfo.auditState === 3">
        <div class="h12"></div>
        <div class="detai-list-3">
          <p class="number">原因</p>
          <p class="remark">{{activeInfo.rebutReason}}</p>
        </div>
      </div>

      <div class="baojia"  v-if="activeInfo.quoteState === 2">
        <van-checkbox v-model="isCheckHt" shape="square" icon-size="20px">
        </van-checkbox>
        <span @click="goHT(activeInfo)" style="margin-left: 10px;color: #2F7BFF;text-decoration: underline;">电子合同</span>
        <button type="button" class="submit" @click="showPopup">确认报价</button>
      </div>
    </div>

  </div>
</template>

<script>
  import headers from '@/components/headerslf'
  import { getNeed,changehandle } from '@/api/userPerson/userPerson'
  import { quoteStateFilter,stateFilter,stageFilter,typeFilter } from '@/filters/status'

  export default{
    components: {
      headers
    },
    data() {
      return {
        hraderP: {
          title: '需求详情',
          lefticon: true
        },
        activeInfo:[],
        isCheckHt:false,
        id: 0,
        message:''
      }
    },
    filters: {
      quoteStateFilter,stateFilter,stageFilter,typeFilter
    },
    created () {
      this.id = this.$route.query.id
      this.getNeedDetai();
    },
    methods:{
      showPopup(){
         if(!this.isCheckHt){
            this.$toast('请确认合同')
         }else{
            let obj = {
             id: this.activeInfo.id,
             quoteState: 3
            }
            changehandle(obj).then(res => {
              if (res.data && res.data.respCode == "0000") {
                  this.$toast.success('确认报价成功')
                  setTimeout(() => {
                    this.$router.push('/userPerson/userPerson.html')
                  }, 300)
              }
            })
         }
      },
      getNeedDetai(){
        getNeed(this.id).then(res => {
          console.log(res,'res');
           if (res.data.code === 200) {
            this.activeInfo = res.data.data
            console.log(this.activeInfo);
          }
        })
      },
      cancle(){
         this.show = false;
      },
      goHT(item){
        console.log(item,'item');
        console.log($HMD$.rApi["ENV"]);
        if($HMD$.rApi["ENV"]=='fat'){
          window.open("https://solution.fat.homedo.com/users/contract.html?id=".concat(item.id));
        }else {
          window.open("https://solution.homedo.com/users/contract.html?id=".concat(item.id));
        }
      }
    },

  }
</script>

<style lang="scss">
  .detail{
    .van-popup{
      border-radius: 8px;
    }
    .van-cell{
      background: #F7F8FA;
      margin-left: 5px;
      width: 80%;
    }
  }
</style>
<style lang="scss" scoped>
  .detail{
    background: #F6F6F6;
    .detail-header{
      height: 64px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      color:#fff;
      background-image: url(../../assets/images/back.png);
    }
    .detai-list{
      margin-top: -5px;
      .h12{
        height: 12px;
      }
      .detai-list-1{
        padding: 16px 16px 0 16px;
        background: #FFFFFF;
        border-radius: 10px 10px 0px 0px;
        p{
          margin-bottom: 16px;
        }
        .name{
          font-size: 15px;
          font-weight: bold;
          color: #222222;
          overflow: hidden;
          text-overflow: ellipsis;
          display: box;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .blue{
          color: #2F7BFF;
        }
        .red{
          color: #FF0000;
        }
        .list{
          span{
            display: inline-block;
            padding: 3px 6px;
            background: #EDF4FE;
            border-radius: 2px;
            border: 1px solid #9DC1FF;
            color: #2F7BFF;
            margin-right: 10px;
            margin-bottom: 5px;
          }
        }
      }
    }
    .detai-list-2{
      border-top: 1px dashed #ccc;
      padding-top: 20px;
      p{
        margin-bottom: 14px;
      }
      .item{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .font{
        text-align: right;
        margin-top: -10px;
        padding-bottom: 15px;
      }
      .red{
        color: #FF0000;
      }
    }
    .detai-list-3{
      padding: 16px 16px 0 16px;
      background: #fff;
      .remark{
        padding-bottom: 10px;
      }
      .number{
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 20px;
      }
      .loadImg{
        display: flex;
        align-items: center;
        img{
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
        p{
          color: #2E7BFF;
          text-decoration: underline ;
        }
      }
    }
    .baojia{
      padding: 39px 16px 40px 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        width: 167px;
        height: 44px;
        border-radius: 4px;
        font-weight: 600;
        margin-left: 15px;
      }
      .rejust{
        background: #ECF2FF;
        border: 1px solid #2F7BFF;
        color: #2F7BFF;
        margin-right: 10px;
      }
      .submit{
        background: #2F7BFF;
        border: 1px solid #2F7BFF;
        color: #fff;
      }
    }
  }
  .dialog{
    width: 290px;
    height: 349px;
    background: #FFFFFF;
    border-radius: 8px;
    padding:16px 20px;
    .name{
      font-size: 20px;
      text-align: center;
      font-weight: 600;
      color: #333333;
      padding-bottom: 12px;
      border-bottom: 1px solid #eee;
    }
    .blue{
      font-size: 12px;
      color: #2F7BFF;
    }
    .dialog-item{
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .item-label{
        width: 60px;
        text-align: right;
        font-size: 15px;
        color: #222;
      }
      input{
        width: 160px;
        height: 28px;
        background: #F7F8FA;
        border-radius: 2px;
        border: none;
        margin-left: 5px;
        margin-right: 8px;
        padding-left: 10px;
      }
    }
    .button{
      display: flex;
      justify-content: space-between;
      padding-top: 16px;
      button{
        width: 114px;
        height: 35px;
        border-radius: 8px;
        border: none;
        color: #fff;
      }
      .cancle{
          background: #FFFFFF rgba(47, 123, 255, 0.1);
          color: #2F7BFF;
      }
      .comfirm{
        background: #2F7BFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/userPerson/needlistDetail.vue